import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useGlobalContext } from '../../../Context/GlobalContext';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Cookies from 'js-cookie';



const EditPenalty = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);
    const [fineType, setFineType] = useState(selectedStaff?.staffDetails?.EarlyLeavePolicy?.fineType ?? "DAILY");
    const [gracePeriodMins, setGracePeriodMins] = useState(selectedStaff?.staffDetails?.EarlyLeavePolicy?.gracePeriodMins ?? 0);
    const [fineAmountMins, setFineAmountMins] = useState(selectedStaff?.staffDetails?.EarlyLeavePolicy?.fineAmountMins ?? 0);
    const [waiveOffDays, setWaiveOffDays] = useState(selectedStaff?.staffDetails?.EarlyLeavePolicy?.waiveOffDays ?? 0);

    const [lateFineType, setLateFineType] = useState(selectedStaff?.staffDetails?.LateComingPolicy?.fineType ?? "DAILY");
    const [lateGracePeriodMins, setLateGracePeriodMins] = useState(selectedStaff?.staffDetails?.LateComingPolicy?.gracePeriodMins ?? 0);
    const [lateFineAmountMins, setLateFineAmountMins] = useState(selectedStaff?.staffDetails?.LateComingPolicy?.fineAmountMins ?? 0);
    const [lateWaiveOffDays, setLateWaiveOffDays] = useState(selectedStaff?.staffDetails?.LateComingPolicy?.waiveOffDays ?? 0);

    const [overGracePeriodMins, setOverGracePeriodMins] = useState(selectedStaff?.staffDetails?.OverLeavePolicy?.[0]?.gracePeriodMins ?? 0);
    const [extraHourPay, setExtraHourPay] = useState(selectedStaff?.staffDetails?.OverLeavePolicy?.[0]?.extraHoursPay ?? 0);
    const [publicHolidayPay, setPublicHolidayPay] = useState(selectedStaff?.staffDetails?.OverLeavePolicy?.[0]?.publicHolidayPay ?? 0);
    const [weekOffPay, setWeekOffPay] = useState(selectedStaff?.staffDetails?.OverLeavePolicy?.[0]?.weekOffPay ?? 0);

    const [createPolicy, setCreatedPolicy] = useState({
        earlyLeavePolicy: false,
        lateComingPolicy: false,
        overLeavePolicy: false
    });

    async function submitEarlyLeavePolicy() {
        setIsLoading(true);

        try {
            const response = await fetch(baseUrl + "policy/early", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    fineType: fineType,
                    gracePeriodMins: Number(gracePeriodMins),
                    fineAmountMins: Number(fineAmountMins),
                    waiveOffDays: Number(waiveOffDays),
                    staffId: selectedStaff.staffDetails.id
                })
            });

            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setFineType(result?.fineType);
                setGracePeriodMins(result?.gracePeriodMins);
                setFineAmountMins(result?.fineAmountMins);
                setWaiveOffDays(result?.waiveOffDays);
                setCreatedPolicy((prev) => ({ ...prev, earlyLeavePolicy: true }));
                openToast("Early Leave Policy created Successfully", "success");
            }
            else {
                openToast("An error occurred while creating early leave policy", "error");
            }
        } catch (error) {
            console.error("Error creating early leave policy:", error);
            openToast("An error occurred while creating early leave policy", "error");
        }
        finally {
            setIsLoading(false);
            closeModal12();
        }

    }
    async function editEarlyLeavePolicy() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "policy/early/" + selectedStaff?.staffDetails?.id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    fineType: fineType,
                    gracePeriodMins: Number(gracePeriodMins),
                    fineAmountMins: Number(fineAmountMins),
                    waiveOffDays: Number(waiveOffDays),
                })
            });

            const result = await response.json();
            if (response.status === 200) {
                console.log(result);
                setFineType(result?.fineType);
                setGracePeriodMins(result?.gracePeriodMins);
                setFineAmountMins(result?.fineAmountMins);
                setWaiveOffDays(result?.waiveOffDays);
                openToast("Early Leave Policy update Successfully", "success");
            }
            else {
                openToast(result.message || result.details || "An error occurred while updated early leave policy", "error");
            }
        } catch (error) {
            console.error("Error creating updated leave policy:", error);
            openToast(error.message || error.details || "An error occurred while updated early leave policy", "error");
        }
        finally {
            setIsLoading(false);
            closeModal12();
        }

    }

    async function submitLateComingPolicy() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "policy/late", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    fineType: lateFineType,
                    gracePeriodMins: Number(lateGracePeriodMins),
                    fineAmountMins: Number(lateFineAmountMins),
                    waiveOffDays: Number(lateWaiveOffDays),
                    staffId: selectedStaff.staffDetails.id
                })
            });

            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setCreatedPolicy((prev) => ({ ...prev, lateComingPolicy: true }));
                openToast("Late Coming Policy created Successfully", "success");
            }
            else {
                openToast("An error occurred while creating late coming policy", "error");
            }
        } catch (error) {
            console.error("Error creating late coming policy:", error);
            openToast("An error occurred while creating late coming policy", "error");
        }
        finally {
            setIsLoading(false);
            closeModal13();
        }
    }
    async function editLateComingPolicy() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "policy/late/" + selectedStaff?.staffDetails?.id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    fineType: lateFineType,
                    gracePeriodMins: Number(lateGracePeriodMins),
                    fineAmountMins: Number(lateFineAmountMins),
                    waiveOffDays: Number(lateWaiveOffDays),
                })
            });

            console.log(response);

            if (response.status === 200) {
                const result = await response.json();
                console.log(result);
                openToast("Late Coming Policy updated Successfully", "success");
            }
            else {
                openToast("An error occurred while updating late coming policy", "error");
            }
        } catch (error) {
            console.error("Error updating late coming policy:", error);
            openToast("An error occurred while updating late coming policy", "error");
        }
        finally {
            setIsLoading(false);
            closeModal13();
        }
    }

    async function submitOvertimePolicy() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "policy/overtime", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    gracePeriodMins: Number(overGracePeriodMins),
                    extraHoursPay: Number(extraHourPay),
                    publicHolidayPay: Number(publicHolidayPay),
                    weekOffPay: Number(weekOffPay),
                    staffId: selectedStaff.staffDetails.id
                })
            });

            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setCreatedPolicy((prev) => ({ ...prev, overLeavePolicy: true }));
                openToast("Overtime Policy created Successfully", "success");
            }
            else {
                openToast("An error occurred while creating Overtime policy", "error");
            }
        } catch (error) {
            console.error("Error creating Overtime policy:", error);
            openToast("An error occurred while creating Overtime policy", "error");
        } finally {
            closeModal14();
            setIsLoading(false);
        }

    }
    async function editOvertimePolicy() {
        setIsLoading(true);
        try {
            const response = await fetch(baseUrl + "policy/overtime/" + selectedStaff?.staffDetails?.id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    gracePeriodMins: Number(overGracePeriodMins),
                    extraHoursPay: Number(extraHourPay),
                    publicHolidayPay: Number(publicHolidayPay),
                    weekOffPay: Number(weekOffPay),
                })
            });

            console.log(response);

            if (response.status === 200) {
                const result = await response.json();
                console.log(result);

                openToast("Overtime Policy updated Successfully", "success");
            }
            else {
                openToast("An error occurred while updating Overtime policy", "error");
            }
        } catch (error) {
            console.error("Error updating Overtime policy:", error);
            openToast("An error occurred while updating Overtime policy", "error");
        } finally {
            closeModal14();
            setIsLoading(false);
        }

    }

    let subtitle;
    // when onclick update staff



    // when on click update leave policiy
    const [modalIsOpen12, setIsOpen12] = React.useState(false);
    function openModal12() {
        setIsOpen12(true);
    }
    function afterOpenModal12() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal12() {
        setIsOpen12(false);
    }
    // when on click update leave policy


    // when on click update leave policiy
    const [modalIsOpen13, setIsOpen13] = React.useState(false);
    function openModal13() {
        setIsOpen13(true);
    }
    function afterOpenModal13() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal13() {
        setIsOpen13(false);
    }
    // when on click update leave policy


    // when on click update leave policiy
    const [modalIsOpen14, setIsOpen14] = React.useState(false);
    function openModal14() {
        setIsOpen14(true);
    }
    function afterOpenModal14() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal14() {
        setIsOpen14(false);
    }
    // when on click update leave policy

    useEffect(() => {
        if (selectedStaff?.staffDetails?.EarlyLeavePolicy) {
            setCreatedPolicy(prev => ({ ...prev, earlyLeavePolicy: true }))
        }
        if (selectedStaff?.staffDetails?.LateComingPolicy) {
            setCreatedPolicy(prev => ({ ...prev, lateComingPolicy: true }))
        }
        if (selectedStaff?.staffDetails?.OverLeavePolicy?.length > 0){
            setCreatedPolicy(prev => ({ ...prev, overLeavePolicy: true }))
        }
    }, [

    ])

    return (
        <>
            {/* // <div className='relative flex flex-col p-[20px] xl:p-[40px] pt-[80px] xl:pt-[60px] xl:pl-[320px] w-full'> */}
            <div className='top-0 flex justify-between items-center bg-white p-[20px] pt-[30px] pr-0 pl-[0] w-[100%]'>

                <h3 className='bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium'>Penalty & Overtime Details

                </h3>
                {/* <button className='second-btn'>Update Details</button> */}
            </div>


            <div className='mt-[10px]'>
                <button className='flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start' onClick={openModal12}>Early Leave Policy <ArrowForwardIosIcon className='allarrow-verify' /></button>
                <button className='flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start' onClick={openModal13}>Late Coming Policy <ArrowForwardIosIcon className='allarrow-verify' /></button>
                <button className='flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-md w-full text-[#000] text-[14px] text-start' onClick={openModal14}> Overtime Policy <ArrowForwardIosIcon className='allarrow-verify' /></button>
            </div>
            {/* when onclick leave policies
             */}

            <Modal
                isOpen={modalIsOpen12}
                onAfterOpen={afterOpenModal12}
                onRequestClose={closeModal12}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px]'>Early Leaving Policy</h2>
                <button onClick={closeModal12} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='bg-[#27004a] rounded-2xl text-white' /></button>
                <div className='pt-[20px] pr-3 pb-2 pl-3'>

                    <label className='text-[14px]'>Fine Type</label>
                    <div className='flex justify-between gap-4'>
                        <div className='flex items-center gap-[10px] border-1 mt-1 mb-[10px] p-[8px] pl-[15px] border rounded-md w-[48%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer focus:outline-none'>
                            <input type="radio" id="daily" name="fav_language" checked={fineType === "DAILY"} onChange={(e) => setFineType("DAILY")} />
                            <label for="daily">Daily</label><br />
                        </div>
                        <div className='flex items-center gap-[10px] border-1 mt-1 mb-[10px] p-[8px] pl-[15px] border rounded-md w-[48%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer focus:outline-none'>
                            <input type="radio" id="hourly" name="fav_language" checked={fineType === "HOURLY"} onChange={(e) => setFineType("HOURLY")} />
                            <label for="hourly">Hourly</label><br />
                        </div>
                    </div>

                    <label className='text-[14px]'>Grace Period (mins)
                    </label>
                    <input type='number' className='border-1 newsetup3   mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' placeholder='0' value={gracePeriodMins} onChange={(e) => setGracePeriodMins(e.target.value)} />
                    <label className='text-[14px]'>Fine Amount (mins)
                    </label>
                    <input type='number' className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' placeholder='0' value={fineAmountMins} onChange={(e) => setFineAmountMins(e.target.value)} />

                    <label className='text-[14px]'>Waive Off Days
                    </label>
                    <input type='number' className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' placeholder='0' value={waiveOffDays} onChange={(e) => setWaiveOffDays(e.target.value)} />

                    <div className='pt-4 pb-4 text-center'>
                        <button disabled={isLoading} className={'second-btn ' + (isLoading && 'cursor-not-allowed opacity-50 animate-pulse')} onClick={() => (!createPolicy.earlyLeavePolicy ? submitEarlyLeavePolicy() : editEarlyLeavePolicy())}>Save Early Leave Policy</button>
                    </div>
                </div>
            </Modal>
            {/* when onclick leave policies
             */}




            {/* when onclick leave policies
             */}

            <Modal
                isOpen={modalIsOpen13}
                onAfterOpen={afterOpenModal13}
                onRequestClose={closeModal13}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px]'>Late Coming Policy</h2>
                <button onClick={closeModal13} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>

                <div className='pt-[20px] pr-3 pb-2 pl-3'>

                    <label className='text-[14px]'>Fine Type</label>
                    <div className='flex justify-between gap-4'>
                        <div className='flex items-center gap-[10px] border-1 mt-1 mb-[10px] p-[8px] pl-[15px] border rounded-md w-[48%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer focus:outline-none'>
                            <input type="radio" id="daily" name="fav_language" checked={lateFineType === "DAILY"} value="daily" onChange={(e) => ("DAILY")} required />
                            <label for="daily">Daily</label><br />
                        </div>
                        <div className='flex items-center gap-[10px] border-1 mt-1 mb-[10px] p-[8px] pl-[15px] border rounded-md w-[48%] placeholder:font-font-normal text-[#000] text-[14px] cursor-pointer focus:outline-none'>
                            <input type="radio" id="hourly" name="fav_language" checked={lateFineType === "HOURLY"} value="hourly" onChange={(e) => setLateFineType("HOURLY")} required />
                            <label for="hourly">Hourly</label><br />
                        </div>
                    </div>

                    <label className='text-[14px]'>Grace Period (mins)
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={lateGracePeriodMins} onChange={(e) => setLateGracePeriodMins(e.target.value)} required />
                    <label className='text-[14px]'>Fine Amount (mins)
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={lateFineAmountMins} onChange={(e) => setLateFineAmountMins(e.target.value)} required />

                    <label className='text-[14px]'>Waive Off Days
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={lateWaiveOffDays} onChange={(e) => setLateWaiveOffDays(e.target.value)} required />

                    <div className='pt-4 pb-4 text-center'>
                        <button disabled={isLoading} className={'second-btn ' + (isLoading && 'cursor-not-allowed opacity-50 animate-pulse')} onClick={() => (!createPolicy.lateComingPolicy ? submitLateComingPolicy() : editLateComingPolicy())}>Save Late Coming Policy</button>
                    </div>
                </div>
            </Modal>
            {/* when onclick leave policies
             */}

            {/* when onclick leave policies
             */}

            <Modal
                isOpen={modalIsOpen14}
                onAfterOpen={afterOpenModal14}
                onRequestClose={closeModal14}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px]'>Overtime Policy</h2>
                <button onClick={closeModal14} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className='pt-[20px] pr-3 pb-2 pl-3'>



                    <label className='text-[14px]'>Grace Period (mins)
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={overGracePeriodMins} onChange={(e) => setOverGracePeriodMins(e.target.value)} />
                    <label className='text-[14px]'>Extra Hours Pay
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={extraHourPay} onChange={(e) => setExtraHourPay(e.target.value)} />

                    <label className='text-[14px]'>Public Holiday Pay
                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={publicHolidayPay} onChange={(e) => setPublicHolidayPay(e.target.value)} />

                    <label className='text-[14px]'>Week Off Pay

                    </label>
                    <input type='number' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' placeholder='0' value={weekOffPay} onChange={(e) => setWeekOffPay(e.target.value)} />


                    <div className='pt-4 pb-4 text-center'>
                        <button disabled={isLoading} className={'second-btn ' + (isLoading && 'cursor-not-allowed opacity-50 animate-pulse')} onClick={() => (!createPolicy.overLeavePolicy ? submitOvertimePolicy() : editOvertimePolicy())}>Save Overtime Policy</button>
                    </div>


                </div>
            </Modal>
            {/* when onclick leave policies
             */}



            {/* </div> */}
        </>
    )
}

export default EditPenalty